import { Component } from "react";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import { getCircularCompany_action, assignCircular_action, getCircularList_action, insertCicular_action, delCircular_action, getCircularHistory_action } from "../../../actions/admin_module_action/circular_actions/circular_action";
import { exhibitorTypeActionId, paymentTypeActionId, toastError, toastSuccess, categoryActionID, DOC_BASE_URL } from "../../../utils/constants";
// import { assignCircular_action } from "../../../actions/admin_module_action/visitorCircular_action/visitorCircular_action";
import { data } from "jquery";
import Pagination from "../../../utils/pagination";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Resizer from "react-image-file-resizer";
import Modal from "react-modal";
import { fill_action } from "../../../actions/fillCombo_action";
import Workbook from 'react-excel-workbook'

import ConfirmationModal from "../../../common_components/confirmationa_modal";

class CircularAdd extends Component {
    // Initialized 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            companyList: [],
            currentPage: 1,
            circularList: [],
            circularDate: "",
            circularTitle: "",
            circularFile: "",
            circularFileType: "",
            checkedAll: false,
            selectedCompany: [],
            isDelOpen: false,
            circularID: "",
            companyName: "",
            paymentTypeId: 0,
            exhibitorTypeId: 0,
            paymentTypeList: [],
            exhibitorTypeList: [],
            loginAccesslist: [],

            // Err Messages
            circularDateErr: "",
            circularTitleErr: "",
            circularFileErr: "",
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,

            isSendMail: false,

            isHistoryOpen: false,
            historyList: [],
            historyCircularTitle: "",
            circularFileName: ''
        }
        this.getCircularCompany = this.getCircularCompany.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.getCircularList = this.getCircularList.bind(this)
        this.insertCircular = this.insertCircular.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.selectAllCompany = this.selectAllCompany.bind(this)
        this.handleCheckedCompany = this.handleCheckedCompany.bind(this)
        this.delCircular = this.delCircular.bind(this)
        this.toggleDelModal = this.toggleDelModal.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this)
        this.getWriteAccess = this.getWriteAccess.bind(this)
        this.getDeleteAccess = this.getDeleteAccess.bind(this)
        this.checkedCirculars = this.checkedCirculars.bind(this)
        this.assignCircular = this.assignCircular.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
        this.openHistoryModal = this.openHistoryModal.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.insertCircular()
            }
            if (confirmationObj.action == 1) {
                this.assignCircular()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }


    // Om Component Load
    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(categoryActionID, '', '', '', '', '');
        this.getFillList(exhibitorTypeActionId, '', '', '', '', '');
        this.getCircularCompany()
        this.getCircularList()
    }

    // Get Circular Company 
    getCircularCompany() {
        const { paymentTypeId, exhibitorTypeId, companyName } = this.state
        this.setState({ isLoading: true })
        this.props.getCircularCompany_action(paymentTypeId != "" && paymentTypeId != "Select Payment Type" ? paymentTypeId : 0,
            exhibitorTypeId != "" && exhibitorTypeId != "Select Exhibitor Type" ? exhibitorTypeId : 0, companyName
        )
            .then((data) => {
                if (data.error != 1) {
                    data.data.length > 0 && data.data.map((item) => {
                        item.Is_Select = false
                    })
                    console.log("getCircularCompany Data", data.data)
                    this.setState({
                        companyList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // Update Current Page
    updateItem(item) {
        const { companyList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = companyList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(companyList.length / recordsPerPage)
    }

    // Get Circular List
    getCircularList() {
        this.setState({ isLoading: true })
        this.props.getCircularList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("getCircularList Data", data.data)
                    data.data.length > 0 && data.data.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        circularList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    handleClear() {
        const { companyName, paymentTypeId, isSendMail, exhibitorTypeId } = this.state

        this.setState({
            companyName: '',
            paymentTypeId: "",
            exhibitorTypeId: "",
            currentPage: 1,
            circularDate: '',
            circularTitle: '',
            circularFile: '',
            circularFileName: '',
            circularFileType: '',
            checkedAll: false,
            isSendMail: false
        })
        setTimeout(() => {
            this.getCircularCompany()
            this.getCircularList()
        }, 200);
    }

    // Insert Circular 
    insertCircular(e) {
        const { circularDate, circularFile, circularTitle, circularDateErr, circularFileErr, isSendMail, circularTitleErr, companyList, circularFileType } = this.state
        this.inputValidate()
        // var selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
        if (circularDate != "" && circularTitle != "" && circularFile != "") {
            if (circularDateErr == "" && circularTitleErr == "" && circularFileErr == "") {
                var selectedCompany = []
                selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
                if (selectedCompany.length > 0) {
                    // circular data Preparing to store
                    var list = []
                    selectedCompany.map(data => {
                        var mapData = {
                            'AccountID': parseInt(data.AccountID),
                            'ExhRegistrationID': parseInt(data.ExhRegistrationID),
                        }
                        list.push(mapData)
                    });

                    this.setState({ isLoading: true })
                    this.props.insertCicular_action(circularDate, circularTitle, circularFile, list, circularFileType, isSendMail)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({ isLoading: false })
                                toastSuccess("Circular Added Successfully")
                                // this.props.navigate('/addcircular')
                                // window.location.reload()
                                this.setState({
                                    circularDate: '',
                                    circularTitle: '',
                                    circularFile: '',
                                    circularFileType: '',
                                }, () => {
                                    this.getCircularCompany()
                                    this.getCircularList()
                                    this.handleClear()
                                })
                            } else {
                                this.setState({ isLoading: false })
                                toastError(data.msg)
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                } else {
                    toastError("Please Select Atleast One Company")
                }
            } else {
                toastError("Please Fill Mandatory Input Fields")
            }
        } else {
            toastError("Please Fill Mandatory Input Fields")
        }



    }

    // Input Feilds Validation
    inputValidate() {
        const { circularDate, circularTitle, circularFile } = this.state

        if (circularDate == "") {
            this.setState({ circularDateErr: 'Please Select Circular Date' })
        }
        if (circularTitle == "") {
            this.setState({ circularTitleErr: 'Please Enter Circular Title' })
        }
        if (circularFile == "") {
            this.setState({ circularFileErr: 'Please Select Circular File' })
        }
    }

    // On Cicular File Select
    onFilePick = async (e, file) => {
        e.preventDefault()
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                this.setState({
                    circularFile: '',
                    circularFileType: '',
                    // passportFileType: '',
                    // passportFilePath: '',
                })
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf')

                ) {
                    image = await this.onPdfSelect(file[0]);
                    this.setState({ circularFile: image, circularFileName: file[0]['name'], circularFileErr: '' })

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ circularFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                } else {
                    toastError('Only .pdf files are allowed')
                    this.setState({
                        circularFile: '',
                        circularFileName: '',
                        circularFileType: '',
                        // passportFileType: '',
                        // passportFilePath: '',
                    })
                }
            }
        }
        else {
            this.setState({
                circularFile: '',
                circularFileType: '',
                // passportFileType: '',
                // passportFilePath: '',
            })
        }
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    //on Select All Click
    selectAllCompany(e) {
        const { checkedAll, companyList } = this.state
        this.setState({ checkedAll: !checkedAll })
        const checked = e.target.checked
        companyList.length > 0 && companyList.map((data) => {
            if (checked) {
                data.Is_Select = true
            } else {
                data.Is_Select = false
            }
        })
        console.log("yyyyyyyyyyyyy", companyList)
        this.setState({ selectedCompany: companyList })
    }

    // On Checked Company
    handleCheckedCompany(e, id) {
        const { companyList, selectedCompany } = this.state
        const checked = e.target.checked

        companyList.length > 0 && companyList.map((data) => {
            if (data.ExhRegistrationID == id) {
                if (checked) {
                    data.Is_Select = true
                } else {
                    data.Is_Select = false
                    this.setState({ checkedAll: false })
                }
            }
        })
        console.log("aaaaaaaaaaa", companyList)
        this.setState({})
    }

    // On Delete Circular
    delCircular(e) {
        const { circularID } = this.state
        this.setState({ isLoading: true })
        this.props.delCircular_action(circularID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        isDelOpen: false,
                        isLoading: false
                    })
                    toastSuccess("Circular Deleted Successfully")
                    this.getCircularList()
                    this.handleClear()
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    //toggle for delete
    toggleDelModal(id) {
        const { isDelOpen } = this.state
        this.setState({
            isDelOpen: !isDelOpen, circularID: id
        })
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // Payment Type list
                    if (actionID === categoryActionID) {
                        this.setState({
                            paymentTypeList: data.data.length > 0 ? data.data : [],
                            isLoading: false
                        })
                    }
                    // Exhibitor Type list
                    if (actionID === exhibitorTypeActionId) {
                        console.log("Exhibitor Type list data", data.data)
                        this.setState({
                            exhibitorTypeList: data.data.length > 0 ? data.data : [],
                            isLoading: false
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // On Search Click
    onSearchClick() {
        this.getCircularCompany()
        setTimeout(() => {
            this.setState({
                currentPage: 1
            })
        }, 200);
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '14');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '14');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    checkedCirculars(e, id) {
        const { circularList } = this.state
        const checked = e.target.checked

        circularList.length > 0 && circularList.map((data) => {
            if (data.CircularID == id) {
                if (checked) {
                    data.isSelect = true
                } else {
                    data.isSelect = false
                }
            }
        })
        console.log("aaaaaaaaaaa", circularList)
        this.setState({})
    }

    assignCircular() {
        const { circularList, companyList } = this.state
        var selectedCompany = []
        selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
        var selectedCircular = []
        selectedCircular = circularList.length > 0 && circularList.filter((item) => item.isSelect == true)

        if (selectedCircular.length > 0) {
            if (selectedCompany.length > 0) {
                // circular User data Preparing to store
                var list = []
                selectedCompany.map(data => {
                    var mapData = {
                        'AccountID': parseInt(data.AccountID),
                        'ExhRegistrationID': parseInt(data.ExhRegistrationID),
                    }
                    list.push(mapData)
                });
                // circular data Preparing to store
                var list2 = []
                selectedCircular.map(data => {
                    var mapData = {
                        'CircularID': parseInt(data.CircularID),
                    }
                    list2.push(mapData)
                });
                this.setState({ isLoading: true })
                this.props.assignCircular_action(list, list2, 0, this.state.isSendMail)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false, isSendMail: false })
                            toastSuccess("Circular Assign Successfully")
                            this.handleClear()
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please Select Atleast One Exhibitor")
            }
        } else {
            toastError("Please Select Atleast One Circular")
        }
    }


    openHistoryModal(circularID, circularTitle) {
        this.setState({ isHistoryOpen: true, historyList: [], historyCircularTitle: circularTitle, isLoading: true })
        this.props.getCircularHistory_action(circularID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ historyList: data.data, isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    // handleClear() {
    //     this.setState({
    //         companyName: '',
    //         paymentTypeId: 0,
    //         exhibitorTypeId: 0,
    //         isSendMail: false
    //     }, () => {
    //         this.getCircularCompany()
    //         this.getCircularList()
    //     })
    // }

    render() {
        const { isLoading, companyList, currentPage, circularDate, circularTitle, circularDateErr, circularTitleErr, circularFileErr, isOpenConfirmationModal,
            checkedAll, circularList, isDelOpen, companyName, paymentTypeId, exhibitorTypeId, paymentTypeList, exhibitorTypeList,
            isHistoryOpen, historyList, historyCircularTitle, circularFileName
        } = this.state

        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = companyList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(companyList.length / recordsPerPage)

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="main-content app-content with-dr-container">
                    <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 py-2 px-3 text-white">Exhibitor Circular</h6>
                            </div>
                        </div>
                    </div>
                    <main id="main" className="px-3">
                        <section class="section p-0" >
                            <div className="main-container py-2 px-0">
                                <div className="row m-0">
                                    <div className="admin-top-space px-0 pt-0 pb-2">
                                        {/* No outer frame: the Add / All Circulars cards inside are the boxes */}
                                        <div className="card rounded-0 border-0 shadow-none">
                                            {/* <div className="card-header p-2">
                                        <h3 className="card-title">Add Circular</h3>
                                    </div> */}
                                            <div className="card-body p-0">
                                                <div className="row">
                                                    <div className="col-md-5">
                                                        <div className="card shadow-sm border mb-3" style={{ borderRadius: '8px' }}>
                                                            <div className="card-header bg-white border-bottom p-3 p-3 pt-1">
                                                                <h6 className="mb-0 section-title fw-semibold">Add Circular</h6>
                                                            </div>
                                                            <div className="card-body p-2">
                                                                <div className="row m-0">
                                                                    <div className="col-md-6 p-0 pe-2 mb-2">
                                                                        <label htmlFor="validationCustom03" className="fw-semibold mb-2">Circular Name <span style={{ color: 'red' }}>*</span></label>
                                                                        <input type="text" className="form-control"
                                                                            placeholder="Enter circular name"
                                                                            value={circularTitle}
                                                                            onInput={toInputUppercase}
                                                                            onChange={(e) => this.setState({ circularTitle: e.target.value, circularTitleErr: "" })}
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{circularTitleErr}</span>}
                                                                    </div>
                                                                    <div className="col-md-6 p-0 ps-2 mb-2">
                                                                        <label htmlFor="validationCustom03" className="fw-semibold mb-2">Circular Date <span style={{ color: 'red' }}>*</span></label>
                                                                        <DatePicker
                                                                            className="form-control w-100"
                                                                            value={circularDate ? dayjs(circularDate) : null}
                                                                            format="YYYY-MM-DD"
                                                                            onChange={(date) => {
                                                                                if (date) {
                                                                                    this.setState({ circularDate: new Date(Date.UTC(date.year(), date.month(), date.date())), circularDateErr: "" });
                                                                                } else {
                                                                                    this.setState({ circularDate: null, circularDateErr: "" });
                                                                                }
                                                                            }}
                                                                            placeholder="yyyy-mm-dd"
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{circularDateErr}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-12 p-0 mt-1 mb-1">
                                                                    <label htmlFor="validationCustom03" className="fw-semibold mb-2">Upload Circular <span style={{ color: 'red' }}>*</span></label>

                                                                    <div className="p-3 border text-center d-flex flex-column align-items-center justify-content-center" style={{ position: 'relative', borderStyle: 'dashed !important', borderWidth: '2px', borderColor: '#d3e2e5', borderRadius: '8px', backgroundColor: '#fbfcfc' }}>
                                                                        {circularFileName != "" ? (
                                                                            <>
                                                                                <div className="chooseStallFile w-100 m-0" style={{ justifyContent: "space-between" }}>
                                                                                    <p className="overflow-membership m-0 w-100 text-truncate">{circularFileName}</p>
                                                                                    <span
                                                                                        className="membership_file_cross text-danger ms-2"
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={(e) => {
                                                                                            this.setState({
                                                                                                circularFile: '',
                                                                                                circularFileName: '',
                                                                                                circularFileType: '',
                                                                                            })
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <input type="file" className="form-control"
                                                                                    accept=".pdf"
                                                                                    onChange={e => this.onFilePick(e, e.target.files)}
                                                                                    style={{ opacity: 0, position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                                                                                />
                                                                                <i className="fa fa-upload mb-2" style={{ fontSize: '24px', color: '#38a599' }}></i>
                                                                                <h6 className="mb-1 fw-bold" style={{ color: '#38a599' }}>Upload a file <span className="text-muted fw-normal">or drag and drop</span></h6>
                                                                                <p className="mb-0" style={{ fontSize: '12px', color: '#38a599' }}>(Only .pdf file are allowed with maximum size of 5mb)</p>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{circularFileErr}</span>}
                                                                </div>
                                                                <div className="d-flex gap-3 mt-3">
                                                                    <button type="button" className="btn px-4 py-2 btn-aqua"
                                                                        disabled={!this.getWriteAccess()}
                                                                        onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                                                                    >
                                                                        Add Circular
                                                                    </button>
                                                                    <button type="button" className="btn px-4 py-2 btn-aqua"
                                                                        disabled={!this.getWriteAccess()}
                                                                        onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Assign?`, buttonName: "Assign", action: 1 }, popArg: [] })}
                                                                    >
                                                                        Assign Circular
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7">
                                                        <div className="card shadow-sm border mb-3" style={{ borderRadius: '8px' }}>
                                                            <div className="card-header bg-white border-bottom p-3 p-3 pt-1 d-flex justify-content-between align-items-center">
                                                                <h6 className="mb-0 section-title fw-semibold">All Circulars</h6>
                                                                <span className="text-muted" style={{ fontSize: '14px' }}>Total: {circularList.length}</span>
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="p-3" style={{ height: '300px', overflowY: 'auto' }}>
                                                                    {
                                                                        circularList.length > 0 && circularList.map((data, index) => (
                                                                            <div key={Math.random()} className="d-flex align-items-center justify-content-between mb-3">
                                                                                <div className="d-flex align-items-center gap-3">
                                                                                    <input type="checkbox"
                                                                                        value={data.isSelect}
                                                                                        checked={data.isSelect}
                                                                                        onChange={(e) => this.checkedCirculars(e, data.CircularID)}
                                                                                        style={{ width: '18px', height: '18px', cursor: 'pointer', margin: 0 }}
                                                                                    />
                                                                                    <span style={{ color: '#4a5568', fontWeight: '500' }}>{data.CircularDescription}</span>
                                                                                </div>
                                                                                <div className="d-flex gap-2">
                                                                                    <div
                                                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                                                        style={{ width: '32px', height: '32px', backgroundColor: '#f1f3f5', cursor: 'pointer' }}
                                                                                        onClick={() => window.open(DOC_BASE_URL + data.Attachment, "_blank")}
                                                                                    >
                                                                                        <i className="fa fa-eye" title="View Document" style={{ color: '#6c757d', fontSize: '14px' }} />
                                                                                    </div>
                                                                                    <div
                                                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                                                        style={{ width: '32px', height: '32px', backgroundColor: '#f1f3f5', cursor: 'pointer' }}
                                                                                        onClick={() => this.openHistoryModal(data.CircularID, data.CircularDescription)}
                                                                                    >
                                                                                        <i className="fa fa-info" title="View History" style={{ color: '#6c757d', fontSize: '14px' }} />
                                                                                    </div>
                                                                                    <div
                                                                                        className={`rounded-circle d-flex align-items-center justify-content-center ${this.getDeleteAccess() ? '' : 'disabled'}`}
                                                                                        style={{ width: '32px', height: '32px', backgroundColor: '#f1f3f5', cursor: this.getDeleteAccess() ? 'pointer' : 'not-allowed' }}
                                                                                        onClick={() => this.getDeleteAccess() && this.toggleDelModal(data.CircularID)}
                                                                                    >
                                                                                        <i className="fa fa-trash" title="Delete" style={{ color: '#6c757d', fontSize: '14px' }} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* filter-grid: fields, buttons and Send Mail share the line and wrap with the screen */}
                                                    <div className="mb-2">
                                                        <hr className="mt-1 mb-2" />
                                                        <div className="filter-grid">

                                                        <div>
                                                            <label htmlFor="validationCustom03">Company Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Search Company"
                                                                value={companyName}
                                                                onChange={(e) => this.setState({ companyName: e.target.value })}
                                                            />
                                                        </div>
                                                        <div>
                                                            <label htmlFor="validationCustom03">Category</label>
                                                            <select className="form-control"
                                                                value={paymentTypeId}
                                                                onChange={(e) => this.setState({ paymentTypeId: e.target.value })}
                                                            >
                                                                <option value={0}>Select Category</option>
                                                                {
                                                                    paymentTypeList.length > 0 && paymentTypeList.map((data) => (
                                                                        <option key={data.ID} value={data.ID}>{data.Name}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label htmlFor="validationCustom03">Exhibitor Type</label>
                                                            <select className="form-control"
                                                                value={exhibitorTypeId}
                                                                onChange={(e) => this.setState({ exhibitorTypeId: e.target.value })}
                                                            >
                                                                <option>Select Exhibitor Type</option>
                                                                {
                                                                    exhibitorTypeList.length > 0 && exhibitorTypeList.map((data) => (
                                                                        <option key={data.ID} value={data.ID}>{data.ExhibitorType}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="filter-actions">
                                                            <button class="btn btn-aqua"
                                                                onClick={(e) => this.onSearchClick()}
                                                            >Search</button>
                                                            <button class="btn btn-aqua"
                                                                onClick={(e) => this.handleClear()}>Clear</button>
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ minHeight: 38 }}>
                                                            <label className="d-inline-flex align-items-center text-nowrap mb-0" style={{ cursor: 'pointer' }}>
                                                                <input className="me-2" type="checkbox"
                                                                checked={this.state.isSendMail}
                                                                onChange={(e) => this.setState({ isSendMail: !this.state.isSendMail })}
                                                            />
                                                            Send Mail
                                                            </label>
                                                        </div>

                                                    </div>
                                                    </div>
                                                    <div className="row m-0 px-0">
                                                        <div className="table-responsive">
                                                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-center" style={{ width: 60 }}>
                                                                            <input type="checkbox"
                                                                                checked={checkedAll}
                                                                                onChange={(e) => this.selectAllCompany(e)}
                                                                            />
                                                                        </th>
                                                                        <th>Reference ID</th>
                                                                        <th>Company</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        currentRecords.length > 0 ? currentRecords.map((data) => (
                                                                            <tr key={Math.random()}>
                                                                                <td className="text-center">
                                                                                    <input type="checkbox"
                                                                                        value={data.isSelected}
                                                                                        checked={data.Is_Select}
                                                                                        onChange={(e) => this.handleCheckedCompany(e, data.ExhRegistrationID)}
                                                                                    />
                                                                                </td>
                                                                                <td>{data.ExhRegistrationNo}</td>
                                                                                <td>{data.CompanyName}</td>
                                                                            </tr>
                                                                        )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="mt-2 float-left trp">
                                                            {
                                                                companyList.length > 0 ?
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                    /> : <></>
                                                            }
                                                            <div className="table-record-pages " style={{ float: "right" }}>
                                                                <p>{`${currentPage} of ${nPages} pages`}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div >

                <Modal isOpen={isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Confirm Delete</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isDelOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this record?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua" onClick={(e) => this.delCircular(e)}>Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDelOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                {isHistoryOpen && (
                    <>
                        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 99998 }} onClick={() => this.setState({ isHistoryOpen: false })} />
                        <div style={{ position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                            <div style={{ background: '#fff', borderRadius: '6px', width: '90vw', maxWidth: '1200px', height: '80vh', display: 'flex', flexDirection: 'column', pointerEvents: 'all', boxShadow: '0 5px 30px rgba(0,0,0,0.3)' }}>
                                <div className="modal-header p-2" style={{ borderBottom: '1px solid #dee2e6', flexShrink: 0 }}>
                                    <h5 className="modal-title">Circular History — {historyCircularTitle}</h5>
                                    <button type="button" className="close pop-close" style={{ background: 'none', backgroundColor: 'transparent', border: 'none' }} onClick={() => this.setState({ isHistoryOpen: false })}>
                                        <span aria-hidden="true" className="pop-cancel">&times;</span>
                                    </button>
                                </div>
                                <div className="m-2 p-0" style={{ flex: 1, overflowY: 'auto', overflowX: 'auto', padding: '12px' }}>
                                    {historyList.length > 0 ? (() => {
                                        const columns = Object.keys(historyList[0]).filter(col => !col.toLowerCase().includes('id'));
                                        // Address wraps (the table is text-nowrap, so long addresses made the column very wide)
                                        const addressColStyle = { whiteSpace: 'normal', minWidth: '220px', maxWidth: '320px', width: '320px' };
                                        // State / Designation: compact, wrapping (they took far more width than their values need)
                                        const narrowColStyle = { whiteSpace: 'normal', minWidth: '100px', maxWidth: '160px', width: '160px' };
                                        const colStyle = (col) => { const c = col.toLowerCase(); return c.includes('address') ? addressColStyle : (c.includes('state') || c.includes('designation')) ? narrowColStyle : undefined; };
                                        return (
                                            /* sticky-table: the headings stay fixed while the rows scroll */
                                            <table className="table table-bordered table-sm text-nowrap mb-0 sticky-table">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.No</th>
                                                        {columns.map((col) => (
                                                            <th key={col} style={colStyle(col)}>{col}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {historyList.map((row, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            {columns.map((col) => (
                                                                <td key={col} style={colStyle(col)}>{row[col] != null ? String(row[col]) : '-'}</td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        );
                                    })() : (
                                        <p className="text-center mt-3">No history found.</p>
                                    )}
                                </div>
                                <div className="modal-footer p-2" style={{ borderTop: '1px solid #dee2e6', flexShrink: 0 }}>
                                    {historyList.length > 0 && (() => {
                                        const columns = Object.keys(historyList[0]).filter(col => !col.toLowerCase().includes('id'));
                                        const excelData = historyList.map((row, i) => {
                                            const mapped = { 'Sr.No': i + 1 };
                                            columns.forEach((col) => {
                                                mapped[col] = row[col] != null ? row[col] : '-';
                                            });
                                            return mapped;
                                        });
                                        return (
                                            <Workbook filename={`CircularHistory_${historyCircularTitle}.xlsx`} element={
                                                <button type="button" className="btn btn-aqua" style={{ marginRight: '5px' }}>
                                                    Export to Excel
                                                </button>
                                            }>
                                                <Workbook.Sheet data={excelData} name="History">
                                                    <Workbook.Column label="Sr.No" value="Sr.No" />
                                                    {columns.map((col) => (
                                                        <Workbook.Column key={col} label={col} value={col} />
                                                    ))}
                                                </Workbook.Sheet>
                                            </Workbook>
                                        );
                                    })()}
                                    <button type="button" className="btn btn-gray" onClick={() => this.setState({ isHistoryOpen: false })}>Close</button>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            </>

        )
    }
}
export default withRouter(connect(null, {
    getCircularCompany_action, getCircularList_action, insertCicular_action, delCircular_action, assignCircular_action,
    fill_action, getCircularHistory_action
})(CircularAdd))